export default "__VITE_ASSET__LhrASY32__"